// extracted by mini-css-extract-plugin
export default {"wrapper":"uga","container":"vga","title":"wga","desc":"xga","usage":"yga","box":"zga","subtitle":"Aga","ingredients":"Bga","carousel":"Cga","ingredientscarousel":"Ega","productinfo":"Fga","ingredientsinfo":"Gga"};
    if(module.hot) {
      // 1726593108544
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  